import { render } from "./VPAAReport.vue?vue&type=template&id=87c1e194"
import script from "./VPAAReport.vue?vue&type=script&lang=js"
export * from "./VPAAReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__